var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "position-relative w-100" },
    [
      _c("b-form-input", {
        ref: "input_ref",
        attrs: {
          disabled: _vm.isDisabled,
          state: _vm.state,
          placeholder: "Вид работ объекта",
          autocomplete: "off"
        },
        on: {
          focus: _vm.onFocusIn,
          blur: _vm.onFocusOut,
          click: function($event) {
            _vm.isFocus = true
          }
        },
        model: {
          value: _vm.query,
          callback: function($$v) {
            _vm.query = $$v
          },
          expression: "query"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "select-input-body-wrapper" }, [
        _vm.selectedItem && !_vm.isFocus
          ? _c("span", { staticClass: "meta-info text-muted" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.selectedItem.rate) +
                  " " +
                  _vm._s(
                    _vm.getUnitByCode(_vm.selectedItem.unit_code).shortName
                  ) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "custom-btn-select",
            attrs: { type: "button", disabled: _vm.isDisabled },
            on: {
              mousedown: function($event) {
                $event.preventDefault()
                return _vm.onClick.apply(null, arguments)
              }
            }
          },
          [
            _vm.query
              ? _c("v-icon", { attrs: { name: "buttons/cross", size: 11 } })
              : _vm.isFocus
              ? _c("v-icon", {
                  attrs: { name: "buttons/collapse_chevrons_down", size: 10 }
                })
              : _c("v-icon", {
                  attrs: { name: "buttons/collapse_chevrons_right", size: 10 }
                })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.isFocus
        ? _c("div", { staticClass: "custom-dropdown-select" }, [
            _c(
              "div",
              { staticClass: "custom-dropdown-list-scroll" },
              _vm._l(_vm.filteredItems, function(item) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticClass: "custom-dropdown-select-item",
                    on: {
                      mousedown: function($event) {
                        $event.preventDefault()
                        return _vm.onSelect(item)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between text-small w-100"
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(item.work_type_name) +
                            "\n          "
                        ),
                        _c("span", { staticClass: "meta-info text-muted" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.rate) +
                              " " +
                              _vm._s(
                                _vm.getUnitByCode(item.unit_code).shortName
                              ) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.filteredItems.length === 0 && _vm.query
              ? _c(
                  "div",
                  { staticClass: "empty-state-container p-2" },
                  [
                    _c("v-icon", {
                      attrs: { name: "navbar/empty_table", size: 45 }
                    }),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("Ничего не найдено")
                    ])
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33c96050", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c96050","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/LocationWorksSelect.vue
// module id = null
// module chunks = 